import React from 'react';
import Icon from '../../assets/images/icons/activity.png';

const Activity = ({ ...props }) => (
  <img style={{ margin: 'auto' }} width="100%" src={Icon} {...props} alt="icon" />
);

export default Activity;
